import {config} from '../config';

export default {
    getMuleSoftApiUrl: () => config.data.muleSoft.apiUrl,
    getMuleSoftClientId: () => config.data.muleSoft.clientId,
    getMuleSoftCountryCode: () => config.data.muleSoft.country,
};
